package com.solevo.dist.application.models

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant

data class Customer(
    val customerId: String,
    val legalEntityId: String?,
    val currency: String,
    val isBlocked: Boolean?,
    val groupId: String?,
    val company: Company?,
    val creditInfo: CreditInfo?,
    val rebate: Rebate?,
    val rewards: Rewards?,
    val loyalty: Loyalty?,
    val hasOverdueBlockingRule: Boolean?,
    val overdueDays: Int?,
    val minOpenInvoiceDueDate: Instant?,
    val defaultWarehouseId: String?,
    val isManuallyImported: Boolean?,
    val gtcAccepted: Boolean?,
    val isGtcAccepted: String?,
    val loyaltyEnabled: Boolean?,
) {
   val isPickupBlocked: Boolean
        get() {
            if (hasOverdueBlockingRule == true && minOpenInvoiceDueDate != null && overdueDays != null) {
                val overdueDaysToSeconds = overdueDays * 86400
                return (minOpenInvoiceDueDate.epochSeconds + overdueDaysToSeconds) <= Clock.System.now().epochSeconds
            }
            return false
        }

    companion object {
        var customerGroupId: String? = null
    }
}


data class Company(
    val name: String,
    val country: String,
    val street: String,
    val streetNumber: String,
    val city: String,
    val zipcode: String,
    val tier: String,
) {
    val address: String
        get() = "$street $streetNumber, $city"
}

data class CreditInfo(
    val availableCredit: Double,
    val openInvoices: Double,
    val goodsInDelivery: Double,
    val totalCreditLine: Double,
    val availableCreditAfterOpenOrders: Double,
) {
    val openOrders = availableCreditAfterOpenOrders - availableCredit
}

data class Rebate(
    val accruedRebate: Double,
    val rebates: List<RebateEntity>?,
)

data class Rewards(
    val creditScore: Int,
    val paymentTerms: Int,
)

data class RebateEntity(
    val name: String,
    val code: String,
    val value: Double?,
)

data class Loyalty(
    val expirationDate: Instant?,
    val loyaltyCardNumber : String?,
    val loyaltyProgramId : String?,
    val tierId : String?,
    val tierName : List<TierName>?,
    val statusPoints : Int?,
    val totalRewardPoints : Int?,
)

data class TierName (
    var description: String?,
    var languageId: String?,
    var name: String?
)